import { CLOTH, WISH } from './types';

export default {
  title: 'myGiftContent.title',
  toggle: [
    {
      icon: 'myGift/1',
      text: 'myGiftContent.toggle.0.text',
      action: CLOTH,
    },
    {
      icon: 'myGift/postcard',
      text: 'myGiftContent.toggle.1.text',
      action: WISH,
    },
  ],
  buttons: [
    {
      modalData: { action: 'close', data: { type: 'current' } },
      text: 'other.close',
      className: 'custom-button custom-button_gray my-gift__button',
    },
  ],
  itemButtons: [
    {
      className: 'my-gift__filter-button button_my-gift',
      text: {
        equip: 'other.equip',
      },
      icon: {
        equip: 'equipped',
      },
    },
  ],
};
